/**
 * 保证挂载到 window 上的 API 前缀已成功初始化为对象
 * @param apiPrefixList 需要初始化及挂载的 API 前缀列表
 */
export function prepareApi(apiPrefixList) {
  apiPrefixList.forEach(function (key) {
    if (!window[key]) {
      window[key] = {};
    }
  });
}